var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-container"},[(_vm.shouldShowRateLimit)?_c('button',{staticClass:"rate-limit-counter-button",class:{ 'no-questions': _vm.questionsRemaining === 0 },on:{"click":_vm.onClick}},[_c('rolling-number',{attrs:{"value":_vm.questionsRemaining}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }